<script>
export default {
  name: "CustomFooter"
}
</script>

<template>
  <footer class="main">
    <p>© 2026 Carnet d'adresse - Pokeland - CB Inc. v.1.0.2</p>
  </footer>
</template>

<style scoped lang="scss">

footer {
  background: transparent;
  padding: 24px 16px 12px;
}

p {
  text-align: center;
  color: rgba(129, 126, 126, 0.65);
  font-size: 12px;
  margin: 0;
}
</style>
